<!-- 预警告警 -->
<template>
<div v-if="isShowPage" class="early-warning-alarm">
  <div class="header">
    <span class="icon">
      <img src="/static/images/svolt/alarm.png" alt="">
    </span>
    <span class="title">预警告警</span>
    <span class="closeIcon" @click="isShowPage = false">
      <i class="el-icon-close"></i>
    </span>
  </div>
  <div class="content">
    <p>
      <span>项目名称：</span><span>{{alarmMsg.projectname}}</span>
    </p>
    <p>
      <span>告警描述：</span><span>{{alarmMsg.odesc}}</span>
    </p>
    <p>
      <span>事件描述：</span><span>{{alarmMsg.content}}</span>
    </p>
    <p>
      <span>发生时间：</span><span>{{alarmMsg.time}}</span>
    </p>
  </div>
  <div class="footer">
    <span class="detailBtn" @click="alarmDetail()">查看详情</span>
  </div>
</div>
</template>

<script>
export default {
  props: {
    alarmMsg: ''
  },
  data() {
    return {
      isShowPage: true,
    };
  },
  mounted() {},
  methods: {
    alarmDetail() {
      this.$router.push({
        path: '/messageCenter'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.early-warning-alarm {
  width: 400px;
  height: 180px;
  background: rgba(218, 80, 82, 0.84);
  border-radius: 5px;
  border: 1px solid #C5352C;
  color: #fff;

  .header {
    height: 50px;

    .icon {
      width: 30Px;
      height: 30Px;
      margin-top: 15px;
      margin-left: 15px;

      img {
        width: 30px;
        height: 30px;
      }
    }

    .title {
      font-size: 18px;
      font-family: PingFang;
      font-weight: 500;
      line-height: 50px;
      margin-left: 5px;
    }

    .closeIcon {
      width: 15px;
      height: 15px;
      cursor: pointer;
      float: right;
      margin-top: 15px;
      margin-right: 12px;
    }
  }

  .content {
    height: calc(100% - 90px);
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 22px;
    padding-left: 35px;
    padding-right: 35px;
  }

  .footer {
    height: 40px;

    .detailBtn {
      width: 70px;
      height: 30px;
      background: #DA5052;
      border-radius: 3px;
      border: 1px solid #FFFFFF;
      cursor: pointer;
      float: right;
      line-height: 30px;
      margin-right: 18px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/home/components/early-warning-alarm.vue